export default "__VITE_ASSET__Bzwqd6sh__"